import React, { memo } from "react";

const ToggleSwitch = memo(
  ({ className, checked, onChange, disabled = false, name = "" }) => {
    return (
      <label
        className={`${
          disabled ? "toggle-switch-disabled" : "toggle-switch"
        } ${className}`}
      >
        <input
          name={name}
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <span className="switch" />
      </label>
    );
  },
);
export default ToggleSwitch;
